"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyNumbersValidator = void 0;
/**
 * Only numbers
 */
exports.onlyNumbersValidator = /^[0-9]*$/;
